export default __webpack_public_path__ + "static/media/baseline-battery_80-24px.60e01d62.svg";